import { Box, ToggleButtonGroup } from '@mui/material';
import { GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import i18next from 'i18next';
import React from 'react';

import { DateNavigator } from '@commons/DatePickers/DateNavigator';
import Text, { ENUM_FONTS } from '@commons/Text';

import { StyledToggleButton } from './styledComponents';
import { VIEW_MODES } from './constants';

export const SalesPlanningDatagridToolbar = ({
  enableModeChange,
  viewMode,
  handleViewModeChange,
  handleDateChange,
  selectedDate,
  periodPickerState,
  timeSlotsGroupedByDate,
}) => (
  <Box sx={{ p: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
    {/* Left side - Filters */}
    <Box sx={{ display: 'flex', gap: 1 }}>
      <GridToolbarFilterButton />
    </Box>

    {/* Spacer */}
    <Box sx={{ flex: 1 }} />

    {/* Right side - Day Navigation, Mode Change and Search */}

    {enableModeChange && (
      <>
        {/* Day Navigation */}
        {viewMode === VIEW_MODES.DAY && (
          <DateNavigator
            handleDateChange={handleDateChange}
            maxFutureDate={periodPickerState.endDate}
            maxPastDate={periodPickerState.startDate}
            selectedDate={selectedDate}
            timeSlotsGroupedByDate={timeSlotsGroupedByDate}
          />
        )}

        {/* Toggle buttons */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <ToggleButtonGroup
            size="small"
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
          >
            <StyledToggleButton value={VIEW_MODES.CALENDAR}>
              <Text font={ENUM_FONTS.TEXT_SMALL}>
                {i18next.t('FORECAST.SALES_PLANNING.VIEW_MODE_CALENDAR')}
              </Text>
            </StyledToggleButton>
            <StyledToggleButton value={VIEW_MODES.DAY}>
              <Text font={ENUM_FONTS.TEXT_SMALL}>
                {i18next.t('FORECAST.SALES_PLANNING.VIEW_MODE_DAY')}
              </Text>
            </StyledToggleButton>
          </ToggleButtonGroup>
        </Box>
      </>
    )}

    {/* Search */}
    <Box sx={{ display: 'flex', gap: 1 }}>
      <GridToolbarQuickFilter />
    </Box>
  </Box>
);
